import { getStorage } from "../../utilities/setting";
import axiosInstance from "../instances/axiosInstance";

export const getService = async (endpoint, data = "") => {
  const searchString = data ? "?" + new URLSearchParams(data).toString() : "";
  try {
    let response = await axiosInstance({
      method: "GET",
      url: endpoint + searchString,
    });
    if (response) {
      switch (response.status) {
        case 200:
        case 201:
        case 202:
        case 203:
        case 204:
          return { data: response.data, isError: false, error: "" };

        default:
          return {
            data: null,
            isError: true,
            error: "Something went wrong. Please try again",
          };
      }
    }
  } catch (error) {
    if (!error?.response) {
      return {
        data: null,
        isError: true,
        error: "Something went wrong. Please try again",
      };
    }
    switch (error.response.status) {
      case 400:
      case 405:
      case 500:
      case 504:
        return {
          data: null,
          isError: true,
          error: "Something went wrong. Please try again",
        };
      case 401:
        localStorage.clear();

        sessionStorage.clear();
        window.location.href = process.env.REACT_APP_SUB_PATH;
        return {
          data: null,
          isError: true,
          error: "Please check your credentials and try again",
        };
      case 403:
        window.location.href = process.env.REACT_APP_SUB_PATH + "dashboard";
        return {
          data: null,
          isError: true,
          error: "Please check your credentials and try again",
        };

      default:
        return {
          data: null,
          isError: true,
        };
    }
  }
};
